import {
  getEmployerEnrollments,
  changeEmployerEnrollments,
  EmployerEnrollmentActionType,
  getEmployerEnrollmentDetails,
  changeEmployerEnrollmentDetails,
} from '../ducks/employerEnrollment';
import {all, takeLatest} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';
import {EmployerEnrollment} from 'Enrollment/models/EmployerEnrollment';
import {EmployerEnrollmentDetails} from 'Enrollment/models/EmployerEnrollmentDetails';
import enrollmentFileApi from 'Enrollment/api/enrollmentFileApi';
import {PageFetchAction, getPageApiCallGenerator} from 'Shared/utilities/sagaApiGenerators';

const getEmployerEnrollmentsFromApi = (action: ReturnType<typeof getEmployerEnrollments>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EmployerEnrollment>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollments(action.payload.filter);
    },
  })(action.payload);
};

function* fetchEmployerEnrollmentsSaga() {
  yield takeLatest(
    EmployerEnrollmentActionType.GET_EMPLOYER_ENROLLMENTS,
    getPageApiCallGenerator(getEmployerEnrollmentsFromApi, changeEmployerEnrollments)
  );
}

const getEmployerEnrollmentDetailsFromApi = (action: ReturnType<typeof getEmployerEnrollmentDetails>) => {
  return PageFetchAction.match({
    Additional: additionalPage => mergeWithNextPage<EmployerEnrollmentDetails>(additionalPage),
    Initial: () => {
      return enrollmentFileApi.getEnrollmentDetails(action.payload.filter);
    },
  })(action.payload);
};

function* fetchEmployerEnrollmentDetailsSaga() {
  yield takeLatest(
    EmployerEnrollmentActionType.GET_EMPLOYER_ENROLLMENT_DETAILS,
    getPageApiCallGenerator(getEmployerEnrollmentDetailsFromApi, changeEmployerEnrollmentDetails)
  );
}

export default function*() {
  yield all([fetchEmployerEnrollmentsSaga(), fetchEmployerEnrollmentDetailsSaga()]);
}
